const supportedLocales = {
  en: require('date-fns/locale/en'),
  id: require('date-fns/locale/id'),
};

export default function getDateFNSLocale(locale) {
  return supportedLocales[locale] || supportedLocales.id;
}
